import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { KakaoMapUtils } from '../../utils/kakao-map-utils';

declare var kakao: any;

@Component({
  selector: 'np-point-draggable-map',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './np-point-draggable-map.component.html',
  styleUrl: './np-point-draggable-map.component.scss'
})
export class NpPointDraggableMapComponent implements OnInit {

  npInited: boolean = false;

  kakaoMap: any;
  drawRunning: any;

  @Input() point!: any;
  @Output() pointChange = new EventEmitter<any>();

  @Output() mapInited = new EventEmitter<any>();

  constructor(private renderer: Renderer2, private el: ElementRef) {
  }

  ngOnInit(): void {
    this.draw();
  }

  ngOnChanges() {
    this.draw();
    // if (!this.npInited) {
    //   this.draw();
    // }
  }

  draw() {
    if (this.drawRunning) {
      clearTimeout(this.drawRunning);
    }
    this.drawRunning = setTimeout(this.showMap, 500);
  }

  kakaoRef!: ElementRef;

  showMap = () => {

    if (this.kakaoRef) {
      this.renderer.removeChild(this.el.nativeElement, this.kakaoRef);
    }

    if (!this.point || !this.point.x || !this.point.y) {
      return;
    }

    this.npInited = true;

    this.kakaoRef = this.renderer.createElement('div');
    this.renderer.addClass(this.kakaoRef, 'np-kakaomap');
    this.renderer.appendChild(this.el.nativeElement, this.kakaoRef);

    let p = new kakao.maps.LatLng(this.point.y, this.point.x);
    let options = {
      //지도를 생성할 때 필요한 기본 옵션
      center: p, //지도의 중심좌표.
      level: 3 //지도의 레벨(확대, 축소 정도)
    };

    this.kakaoMap = new kakao.maps.Map(this.kakaoRef, options); //지도 생성 및 객체 리턴

    KakaoMapUtils.setWhiteTileSet(this.kakaoMap);

    let marker = new kakao.maps.Marker({
      // image: KakaoMapUtils.getMarkerImageByColor('RED'),
      position: p,
      clickable: false,
      draggable: true
    });
    // 출발 마커에 dragend 이벤트를 등록합니다
    kakao.maps.event.addListener(marker, 'dragend', () => {
      // 출발 마커의 드래그가 종료될 때 마커 이미지를 원래 이미지로 변경합니다
      // startMarker.setImage(startImage);
      const px = marker.getPosition();
      this.pointChange.emit({ x: px.getLng(), y: px.getLat() });
    });
    marker.setMap(this.kakaoMap);
    this.mapInited.emit(this.kakaoMap);

    // 지도가 이동, 확대, 축소로 인해 중심좌표가 변경되면 마지막 파라미터로 넘어온 함수를 호출하도록 이벤트를 등록합니다
    // kakao.maps.event.addListener(this.kakaoMap, 'center_changed', () => {
    //   var center = this.kakaoMap.getCenter();
    //   marker.setPosition(center);
    //   this.pointChange.emit({ x: center.getLng(), y: center.getLat() });
    // })
  }
}
